import React from 'react';
import { CheckIcon } from 'lucide-react';
import { pricingAnchor } from '../data/content';
import { Button } from './ui/Button';
const totals = [['50', 'Proyectos'], ['10', 'Ebooks'], ['400', 'Páginas']] as const;
const finalSteps = ['Elegí el proyecto.', 'Revisá las medidas.', 'Prepará las piezas.', 'Construí paso a paso.'];
export function FinalCta() {
  return <section className="bg-sky-50 px-4 py-12 md:py-16" data-id="element-81" data-mp="1jcvc02pu5yz8">
      <div className="mx-auto max-w-3xl text-center" data-id="element-82" data-mp="1jbahue7foi1w">
        <div className="flex justify-center gap-6 md:gap-12" data-id="element-83" data-mp="1eetsxhsetznr">
          {totals.map(([value, label]) => <div key={label} data-id="element-84" data-mp="1t1wpnm8ws4a1">
              <p className="text-3xl font-black leading-none text-sky-600 md:text-4xl" data-id="element-85" data-mp="1t252je5179l8">{value}</p>
              <p className="mt-1 text-[11px] font-extrabold uppercase tracking-wide text-slate-700 md:text-xs" data-id="element-86" data-mp="1o4n3qgkqaaqy">
                {label}
              </p>
            </div>)}
        </div>

        <h2 className="mt-7 text-xl font-black uppercase leading-tight text-slate-900 md:text-3xl" data-id="element-87" data-mp="1x64edjfd9k89">
          Un proyecto claro para <span className="text-sky-600" data-id="element-88" data-mp="n7yz5aeixytp">cada espacio de tu casa.</span>
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold text-slate-600" data-id="element-89" data-mp="s4xnfcbibbjz">
          No necesitás seguir guardando fotografías de muebles sin saber cuánto medir, qué cortar o
          cómo empezar.
        </p>

        <ol className="mt-6 space-y-1" data-id="element-90" data-mp="164gltdein8j3">
          {finalSteps.map(step => <li key={step} className="text-base font-black uppercase text-slate-900 md:text-lg" data-id="element-91" data-mp="162dyx28ntvil">
              {step}
            </li>)}
        </ol>

        <div className="mt-8" data-id="element-92" data-mp="1fvba0nbboi76">
          <Button href={pricingAnchor} className="w-full !text-base md:w-auto" subtext="Ir a la oferta de lanzamiento" data-id="element-93" data-mp="1fv1qniks99ag">
            🔨 Quiero Muebles Fáciles en Casa →
          </Button>
        </div>

        <p className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-slate-600 md:text-xs" data-id="element-94" data-mp="1ttjdle2v6hrb">
          {['Acceso digital inmediato', 'Acceso de por vida', 'Garantía de 7 días'].map(item => <span key={item} className="flex items-center gap-1" data-id="element-95" data-mp="3lthpevgz1ui7">
                <CheckIcon className="h-3.5 w-3.5 text-sky-600" data-id="element-96" data-mp="3iefghab5jyz" /> {item}
              </span>)}
        </p>
      </div>
    </section>;
}